import api from "../services/api";

export const getOriginFromApi = () => {
  try {
    // Pull origin (scheme + host) from your Axios baseURL
    const u = new URL(api.defaults.baseURL || "");
    // If baseURL is "https://kh-tiling-server.onrender.com/api"
    // this returns "https://kh-tiling-server.onrender.com"
    return `${u.protocol}//${u.host}`;
  } catch (err) {
    console.warn("[getOriginFromApi] Fallback used:", err?.message);
    // Fallback if api.defaults.baseURL is missing (e.g., local dev)
    return "http://localhost:5001";
  }
};

const toAbsolute = (val, origin) => {
  if (typeof val !== "string") return null;
  const v = val.trim();
  if (!v) return null;
  if (/^(https?:)?\/\//i.test(v)) return v; // already absolute
  if (/^(data:|blob:)/i.test(v)) return v;
  return `${origin.replace(/\/+$/, "")}/uploads/${v.replace(/^\/+/, "")}`;
};

/** Returns exactly 4 latest image URLs (client-side cap) */
export const getLatestImages = async () => {
  const { data } = await api.get("/latest/images"); // -> mounted at /api/latest/images
  const origin = getOriginFromApi();

  // Accept either array of strings (URLs/filenames) OR rows with image1..4
  const out = [];
  if (Array.isArray(data)) {
    for (const row of data) {
      if (typeof row === "string") {
        const abs = toAbsolute(row, origin);
        if (abs) out.push(abs);
      } else if (row && typeof row === "object") {
        for (const k of ["image1", "image2", "image3", "image4"]) {
          const abs = toAbsolute(row[k], origin);
          if (abs) out.push(abs);
        }
      }
    }
  } else if (data && typeof data === "object" && Array.isArray(data.data)) {
    for (const item of data.data) {
      if (typeof item === "string") {
        const abs = toAbsolute(item, origin);
        if (abs) out.push(abs);
      } else if (item && typeof item === "object") {
        for (const k of ["image1", "image2", "image3", "image4"]) {
          const abs = toAbsolute(item[k], origin);
          if (abs) out.push(abs);
        }
      }
    }
  }

  // Keep only the latest 4 from whatever order backend provides
  return out.slice(0, 4);
};
